export const WEEK_DAYS = [
  { id: 'monday', label: 'Mon' },
  { id: 'tuesday', label: 'Tue' },
  { id: 'wednesday', label: 'Wed' },
  { id: 'thursday', label: 'Thu' },
  { id: 'friday', label: 'Fri' },
  { id: 'saturday', label: 'Sat' },
  { id: 'sunday', label: 'Sun' },
] as const

export type DayId = (typeof WEEK_DAYS)[number]['id']

export function getTodayDayId(): DayId {
  const index = new Date().getDay()
  const map: DayId[] = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
  return map[index]
}

export function getDayLabel(dayId: string): string {
  return WEEK_DAYS.find((d) => d.id === dayId)?.label ?? dayId
}

export function addDaysFromToday(offset: number): string {
  const d = new Date()
  d.setDate(d.getDate() + offset)
  return d.toISOString().slice(0, 10)
}

/** Calendar ISO date for a weekday in the current week (Mon–Sun). */
export function dayIdForDate(date: Date): DayId {
  const map: DayId[] = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
  return map[date.getDay()] ?? 'monday'
}

export function getTodayIsoDate(): string {
  return new Date().toISOString().slice(0, 10)
}

export function addDaysToIsoDate(isoDate: string, offset: number): string {
  const d = new Date(isoDate + 'T12:00:00')
  d.setDate(d.getDate() + offset)
  return d.toISOString().slice(0, 10)
}

export function getCalendarDateForDayId(dayId: DayId, referenceDate = new Date()): string {
  const targetIndex = WEEK_DAYS.findIndex((d) => d.id === dayId)
  if (targetIndex < 0) return referenceDate.toISOString().slice(0, 10)

  const refDay = referenceDate.getDay()
  const daysFromMonday = refDay === 0 ? 6 : refDay - 1
  const monday = new Date(referenceDate)
  monday.setHours(12, 0, 0, 0)
  monday.setDate(referenceDate.getDate() - daysFromMonday)

  const target = new Date(monday)
  target.setDate(monday.getDate() + targetIndex)
  return target.toISOString().slice(0, 10)
}
